export const getMotionEnabled = () => {
  const prefersReducedMotion =
    typeof window.matchMedia === "function" &&
    window.matchMedia("(prefers-reduced-motion: reduce)").matches;
  const motionEnabled =
    document.documentElement.classList.contains("motion-safe") ||
    !prefersReducedMotion;

  document.documentElement.classList.toggle("motion-safe", motionEnabled);

  return motionEnabled;
};
